import { Toggle } from 'components/tailwind-ui/Toggle';
import * as React from 'react';

interface Props {
  value: boolean;
  setValue: (value: boolean) => void;
  variant: 'current' | 'historic';
}

export const AvgToggle: React.FC<Props> = (props) => {
  const { value, setValue, variant } = props;

  let copy;
  let symbol;
  switch (variant) {
    case 'historic':
      copy = 'Show avg. per diem - past';
      symbol = 'h-0 w-8 border-t-2 border-dashed border-orange-900';
      break;
    case 'current':
    default:
      copy = 'Show avg. per diem';
      symbol = 'h-0 w-8 border-t-2 border-solid border-orange-900';
      break;
  }

  return (
    <div className="flex items-center space-x-2">
      <Toggle value={value} onChange={setValue} />
      <h5>{copy}</h5>
      <div className={symbol} />
    </div>
  );
};
AvgToggle.displayName = 'Shipments.HistoricalPerDiem.ChargesOverTime.Toolbar.AvgToggle';
